export const TRENDMICRO_INTEGRATION_CONFIG_REQUEST = 'TRENDMICRO_INTEGRATION_CONFIG_REQUEST'
export const TRENDMICRO_INTEGRATION_CONFIG_SUCCESS = 'TRENDMICRO_INTEGRATION_CONFIG_SUCCESS'
export const TRENDMICRO_INTEGRATION_CONFIG_ERROR = 'TRENDMICRO_INTEGRATION_CONFIG_ERROR'
export const TRENDMICRO_INTEGRATION_CONFIG_SET = 'TRENDMICRO_INTEGRATION_CONFIG_SET'

export const TRENDMICRO_INTEGRATION_CONFIG_CREATE_REQUEST = 'TRENDMICRO_INTEGRATION_CONFIG_CREATE_REQUEST'
export const TRENDMICRO_INTEGRATION_CONFIG_UPDATE_REQUEST = 'TRENDMICRO_INTEGRATION_CONFIG_UPDATE_REQUEST'
export const TRENDMICRO_INTEGRATION_CONFIG_UPDATE_SUCCESS = 'TRENDMICRO_INTEGRATION_CONFIG_UPDATE_SUCCESS'
export const TRENDMICRO_INTEGRATION_CONFIG_UPDATE_ERROR = 'TRENDMICRO_INTEGRATION_CONFIG_UPDATE_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/integrations/trendmicro-integration.type.js